import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewersService } from '../../../services/viewers.service';
import { SiteConfiguration } from '../../../configuration/configuration';
import { MapViewerLoadMapOptions } from '@3ddv/dvm-internal';

@Component({
  selector: 'app-neighbors',
  imports: [],
  templateUrl: './neighbors.component.html',
  styleUrl: './neighbors.component.css'
})
export class NeighborsComponent implements OnInit {
  @Input() side!: string;
  // View step
  public currentMap!: 'topview' | 'seatmap';
  public is3dView!: boolean;
  private readonly subscriptions: Subscription[] = [];
  // Neighbors data
  private readonly neighborsData: {[key: string]: {l: string, r: string}} = SiteConfiguration.features.neighbors.data;
  public neighborsLabels: {l: string | null, r: string | null} = {l: null, r: null};

  constructor(
    private readonly viewersService: ViewersService,
  ) { }

  ngOnInit(): void {
    // Update the current view step
    this.updateViewStep();
    // Update neighbors
    this.updateNeighbors();
  }

  private updateViewStep(): void {
    // Get 3D View status
    const is3d = this.viewersService.is3dView.subscribe((is3d: boolean) => {
      this.is3dView = is3d;
    });
    // Get Map View status
    const current = this.viewersService.currentMap.subscribe((current: 'topview' | 'seatmap') => {
      this.currentMap = current;
    });
    this.subscriptions.push(is3d, current);
  }

  //#region NEIGHBORS METHODS
  private updateNeighbors(): void {
    const loadSuccess: Subscription = this.viewersService.viewer.getObservable('load_success').subscribe((obj): void => {
      const mapId = this.viewersService.viewer.getMapId()!;
      if (mapId && mapId !== SiteConfiguration.map.dvm.viewer.mapId) {
        this.updateNeighborLabels(mapId);
      }
    });
    this.subscriptions.push(loadSuccess);
  }

  private updateNeighborLabels(mapId: string): void {
    const neighbors = this.neighborsData[mapId];
    this.neighborsLabels = {
      l: neighbors.l.split('_')[1],
      r: neighbors.r.split('_')[1],
    };
  }

  public loadNeighbor(side: 'left' | 'right'): void {
    const mapId = this.viewersService.viewer.getMapId();
    if (!mapId) return;
    const neighbors = this.neighborsData[mapId];
    const neighbor = side === 'left' ? neighbors.l : neighbors.r;
    const navigate = this.viewersService.navigateToSection(neighbor).subscribe();
    this.subscriptions.push(navigate);
  }
  //#endregion

}
